export default {
  common: {
    app_name: 'My Wallets',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    language: 'Language',
    logout: 'Log out',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    required_field: 'This field is required',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    view_all: 'View all',
    profile: 'Profile',
    signOut: 'Sign out',
    asset: 'Asset',
    quantity: 'Quantity',
    details: 'Details',
    refresh_data: 'Refresh',
    refresh_success: 'Data refreshed',
    refresh_error: 'Refresh failed, please try again'
  },
  home: {
    hero: {
      title: 'Manage Your Valuable Assets with Confidence',
      subtitle: 'Track gold, silver, cash, and foreign currencies with real-time market prices. Make informed decisions with our comprehensive asset management platform.',
      getStarted: 'Get Started Free',
      login: 'Log In'
    },
    features: {
      title: 'Why Choose My Wallets?',
      subtitle: 'Our platform provides everything you need to track and manage your valuable assets effectively.',
      realTimeTracking: {
        title: 'Real-Time Price Tracking',
        description: 'Stay updated with hourly price updates for gold, silver, and other assets from trusted sources.'
      },
      transactionHistory: {
        title: 'Complete Transaction History',
        description: 'Keep detailed records of all your buy and sell transactions with precise dates, prices, and quantities.'
      },
      portfolioAnalytics: {
        title: 'Portfolio Analytics',
        description: 'View your portfolio\'s current value and performance with intuitive visualizations and real-time updates.'
      }
    },
    latestPrices: {
      title: 'Latest Market Prices',
      subtitle: 'Stay informed with up-to-date market prices for your valuable assets.',
      asset: 'Asset',
      buyPrice: 'Buy Price',
      sellPrice: 'Sell Price',
      lastUpdated: 'Last Updated',
      loading: 'Loading latest prices...',
      noPriceData: 'No price data available',
      signUpCta: 'Sign Up to Track Your Assets'
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Get started with My Wallets in just a few simple steps',
      step1: {
        title: 'Sign Up',
        description: 'Create your free account with just your name, phone number, and password.'
      },
      step2: {
        title: 'Add Assets',
        description: 'Record your purchases of gold, silver, cash, or foreign currencies.'
      },
      step3: {
        title: 'Track Prices',
        description: 'Get automatic updates on current market prices for all your assets.'
      },
      step4: {
        title: 'Monitor Value',
        description: 'See your portfolio\'s current value based on up-to-date market prices.'
      }
    },
    cta: {
      title: 'Ready to Start Managing Your Assets?',
      subtitle: 'Join thousands of users who trust My Wallets for tracking their valuable assets.',
      createAccount: 'Create Your Free Account',
      signIn: 'Sign In'
    },
    footer: {
      description: 'Track and manage your valuable assets with real-time market prices.',
      quickLinks: 'Quick Links',
      resources: 'Resources',
      documentation: 'Documentation',
      faq: 'FAQ',
      support: 'Support',
      contact: 'Contact',
      email: "nguyenductoan2405{'@'}gmail.com",
      phone: '(+84) 987 802 175',
      copyright: 'All rights reserved.'
    }
  },
  auth: {
    login: 'Login',
    register: 'Register',
    username: 'Username',
    password: 'Password',
    confirm_password: 'Confirm Password',
    name: 'Full Name',
    forgot_password: 'Forgot Password?',
    no_account: 'Don\'t have an account?',
    has_account: 'Already have an account?',
    create_account: 'Create Account',
    invalid_credentials: 'Invalid username or password',
    logout_success: 'You have been logged out successfully',
    password_mismatch: 'Passwords do not match',
    registration_success: 'Registration successful! You can now log in.',
    remember_me: 'Remember me',
    password_requirements: 'Password must be at least 6 characters long'
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    total_assets: 'Total Assets',
    recent_transactions: 'Recent Transactions',
    asset_distribution: 'Asset Distribution',
    assetDistribution: 'Asset Distribution',
    performance: 'Performance',
    performance_period: 'Performance Period',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    all_time: 'All Time',
    no_transactions: 'No recent transactions',
    totalAssetsValue: 'Total Assets Value',
    assetTypes: 'Asset Types',
    transactions: 'Transactions',
    yourAssetBalances: 'Your Asset Balances',
    viewAllBalancesDescription: 'View all your current asset balances and their values.',
    noAssets: 'No assets',
    getStartedMessage: 'Get started by adding your first asset transaction.',
    addTransaction: 'Add Transaction',
    currentPrice: 'Current Price',
    totalValue: 'Total Value',
    noAssetDataAvailable: 'No asset data available',
    savingAssetsByTime: 'Saving Assets by Time',
    noTransactionDataAvailable: 'No transaction data available for the last 12 months',
    creditsBuy: 'Credits (Buy)',
    debitsSell: 'Debits (Sell)',
    credits: 'Credits',
    debits: 'Debits'
  },
  assets: {
    title: 'Assets',
    my_assets: 'My Assets',
    market_price: 'Market Price',
    current_value: 'Current Value',
    buy_price: 'Buy Price',
    sell_price: 'Sell Price',
    unit: 'Unit',
    quantity: 'Quantity',
    no_assets: 'You don\'t have any assets yet',
    refresh_prices: 'Refresh Prices',
    current_market_prices: 'Current Market Prices',
    your_portfolio: 'Your Portfolio',
    no_asset_prices: 'No asset prices available',
    no_portfolio_assets: 'No assets in your portfolio',
    updated_at: 'updated at',
    unrealizedGain: 'Unrealized Gain',
    returnOnInvestment: 'ROI'
  },
  transactions: {
    title: 'Transactions',
    my_transactions: 'My Transactions',
    make_transaction: 'Make Transaction',
    buy: 'Buy',
    sell: 'Sell',
    date: 'Date',
    asset: 'Asset',
    price: 'Price',
    quantity: 'Quantity',
    total: 'Total',
    type: 'Type',
    credit: 'Credit',
    debit: 'Debit',
    description: 'Description',
    filter_by_date: 'Filter by Date',
    filter_by_asset: 'Filter by Asset',
    filter_by_type: 'Filter by Type',
    transaction_success: 'Transaction completed successfully',
    no_transactions: 'No transactions found',
    from_date: 'From Date',
    to_date: 'To Date',
    apply_filters: 'Apply Filters',
    clear_filters: 'Clear Filters',
    new_transaction: 'New Transaction',
    filters: 'Filters',
    hide_filters: 'Hide Filters',
    show_filters: 'Show Filters',
    filter_description: 'By default, transactions from the last 365 days are shown. Use filters to narrow down your search.',
    all_assets: 'All Assets',
    all_types: 'All Types',
    reset: 'Reset',
    refresh: 'Refresh',
    transaction_history: 'Transaction History',
    loading_transactions: 'Loading transactions...',
    transaction_type: 'Transaction Type',
    select_asset: 'Select Asset',
    select_price: 'Select Price',
    recent_prices: 'Showing prices from the last 30 days',
    transaction_date: 'Transaction Date',
    date_time_note: 'Select the date when this transaction occurred. Time will be automatically added.',
    optional: 'Optional',
    transaction_summary: 'Transaction Summary',
    price_date: 'Price Date',
    total_value: 'Total Value',
    submit_transaction: 'Submit Transaction',
    processing: 'Processing...'
  },
  profile: {
    title: 'Profile',
    personal_info: 'Personal Information',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    update_profile: 'Update Profile',
    update_password: 'Update Password',
    profile_updated: 'Profile updated successfully',
    password_updated: 'Password updated successfully',
    incorrect_password: 'Current password is incorrect',
    password_must_be_different: 'New password must be different from current password'
  },
  errors: {
    something_went_wrong: 'Something went wrong',
    network_error: 'Network error. Please check your connection and try again.',
    unauthorized: 'You are not authorized to access this resource',
    session_expired: 'Your session has expired. Please log in again.',
    validation_error: 'Please check the form for errors',
    not_found: 'The requested resource was not found'
  },
  languages: {
    en: 'English',
    vi: 'Vietnamese'
  }
}